import { Icon } from '@chakra-ui/react';
import type { IconProps } from '@chakra-ui/react';

export const GemIcon = (props: Omit<IconProps, 'children' | 'viewBox'>) => (
  <Icon
    fill='none'
    height='100%'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    viewBox='0 0 24 24'
    width='100%'
    {...props}
  >
    <path
      d='M0 0h24v24H0z'
      fill='none'
      stroke='none'
    />
    <path d='M6 5h12l3 5-8.5 9.5a.7.7 0 0 1-1 0L3 10l3-5' />
    <path d='M10 12l-2-2.2.6-1' />
  </Icon>
);

export default GemIcon;
